import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUIComponents, use, useTranslate } from "@bluelibs/x-ui";
import * as Ant from "antd";
import { TokenCreateForm } from "../../config/TokenCreateForm";
const formLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};
const formTailLayout = {
    wrapperCol: { offset: 8, span: 16 },
};
export function TokensCreate() {
    const UIComponents = useUIComponents();
    const t = useTranslate();
    const form = use(TokenCreateForm, { transient: true });
    form.build();
    return (_jsxs(UIComponents.AdminLayout, { children: [_jsx(Ant.PageHeader, { title: t("management.tokens.create.header"), onBack: () => window.history.back() }), _jsx(Ant.Card, { children: _jsxs(Ant.Form, { ...formLayout, requiredMark: "optional", onFinish: (document) => form.onSubmit(document), children: [form.render(), _jsx(Ant.Form.Item, { ...formTailLayout, children: _jsx(Ant.Button, { type: "primary", htmlType: "submit", children: t("generics.submit") }) })] }) })] }));
}
